import { ApiService } from "pwapi";

import * as frontLoaderRequests from "custom-models/frontLoader";
import {
  FrontLoadRequestArgs,
  LabFrontLoadRequestArgs,
} from "custom-models/frontLoader";

import {
  frontLoaderConstants,
  FRONT_LOADER_RECORD_BROADCASTED,
} from "./constants";
import { createAsyncSaga, AsyncSagaAction } from "../utils/asyncActions";

// Front-Loader Saga Creator to minimize boilerplate:
const createFrontLoaderSaga = (type: string, requestFn: Function) =>
  createAsyncSaga(
    frontLoaderConstants[`${type}_REQUEST`],
    frontLoaderConstants[`${type}_SUCCESS`],
    frontLoaderConstants[`${type}_FAILURE`],
    () => `front-load/${type}`,
    (args: FrontLoadRequestArgs) => requestFn(args)
  ) as AsyncSagaAction<FrontLoadRequestArgs>;

const createLabFrontLoaderSaga = (type: string, requestFn: Function) =>
  createAsyncSaga(
    frontLoaderConstants[`${type}_REQUEST`],
    frontLoaderConstants[`${type}_SUCCESS`],
    frontLoaderConstants[`${type}_FAILURE`],
    (args: LabFrontLoadRequestArgs) => `labs/${args.lab_id}/front-load/${type}`,
    (args: LabFrontLoadRequestArgs) => requestFn(args)
  ) as AsyncSagaAction<LabFrontLoadRequestArgs>;

// Action/Saga definitions:

export const frontLoadUsers = createFrontLoaderSaga(
  "USERS",
  frontLoaderRequests.frontLoadUsersRequest
);

export const frontLoadLabs = createFrontLoaderSaga(
  "LABS",
  frontLoaderRequests.frontLoadLabsRequest
);

export const frontLoadAccessionPrefixes = createLabFrontLoaderSaga(
  "ACCESSION_PREFIXES",
  frontLoaderRequests.frontLoadAccessionPrefixesRequest
);

export const frontLoadLabStations = createFrontLoaderSaga(
  "LAB_STATIONS",
  frontLoaderRequests.frontLoadLabStationsRequest
);

export const frontLoadClinics = createFrontLoaderSaga(
  "CLINICS",
  frontLoaderRequests.frontLoadClinicsRequest
);

export const frontloadLabClinics = createAsyncSaga(
  frontLoaderConstants.LAB_CLINICS_REQUEST,
  frontLoaderConstants.LAB_CLINICS_SUCCESS,
  frontLoaderConstants.LAB_CLINICS_FAILURE,
  (args: { labstation_id: number }) => `lis/${args.labstation_id}/clinics`,
  (args: { labstation_id: number }) =>
    ApiService.listLisClinics({
      parentLookupLabStationId: args.labstation_id,
      limit: 9999,
      offset: 0,
    })
) as AsyncSagaAction<FrontLoadRequestArgs & { labstation_id: number }>;

export const frontLoadPatients = createLabFrontLoaderSaga(
  "PATIENTS",
  frontLoaderRequests.frontLoadPatientsRequest
);

export const frontLoadCases = createLabFrontLoaderSaga(
  "CASES",
  frontLoaderRequests.frontLoadCasesRequest
);

export const frontLoadAccessions = createLabFrontLoaderSaga(
  "ACCESSIONS",
  frontLoaderRequests.frontLoadAccessionsRequest
);

export const frontLoadWorkProcesses = createLabFrontLoaderSaga(
  "WORK_PROCESSES",
  frontLoaderRequests.frontLoadWorkProcessesRequest
);

export const frontLoadWorkProcessTasks = createLabFrontLoaderSaga(
  "WORK_PROCESS_TASKS",
  frontLoaderRequests.frontLoadWorkProcessTasksRequest
);

export const frontLoadStains = createFrontLoaderSaga(
  "STAINS",
  frontLoaderRequests.frontLoadStainsRequest
);

export const frontLoadLabStains = createLabFrontLoaderSaga(
  "LAB_STAINS",
  frontLoaderRequests.frontLoadLabStainsRequest
);

export const frontLoadExternalLabs = createFrontLoaderSaga(
  "EXTERNAL_LABS",
  frontLoaderRequests.frontLoadExternalLabsRequest
);

export const frontLoadExternalLabStains = createFrontLoaderSaga(
  "EXTERNAL_LAB_STAINS",
  frontLoaderRequests.frontLoadExternalLabStainsRequest
);

export const frontLoadLabPanels = createFrontLoaderSaga(
  "LAB_PANELS",
  frontLoaderRequests.frontLoadLabPanelsRequest
);

export const frontLoadRecordBroadcasted = (message: any) => ({
  type: FRONT_LOADER_RECORD_BROADCASTED,
  payload: message,
});
